<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="(definition$ | async)?.name"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="history">
  <div class="wrapper">
    <ion-list class="history__list">
      <ion-item *ngFor="let date of lastYearMonths" class="history__list__item" [detail]="false">
        <div class="history__list__item__content">
          <div class="history__list__item__line">
            <span class="history__list__item__line__title" [innerHTML]="date | date:'MMMM YYYY'"></span>

            <div *ngIf="(date | isReportFilled:(definition$ | async):(slug$ | async) | async) === 'EMPTY'" (click)="fillReport(date)">
              <ion-button class="history__list__item__line__button" [innerHTML]="'HISTORY.START' | translate"></ion-button>
            </div>

            <div *ngIf="(date | isReportFilled:(definition$ | async):(slug$ | async) | async) === 'PARTIAL'" (click)="fillReport(date)">
              <ion-button class="history__list__item__line__button" color="warning" [innerHTML]="'HISTORY.FINISH' | translate"></ion-button>
            </div>

            <div *ngIf="(date | isReportFilled:(definition$ | async):(slug$ | async) | async) === 'FULL'" (click)="viewReport(date)">
              <ion-button class="history__list__item__line__button" color="success" [innerHTML]="'HISTORY.SENT' | translate"></ion-button>
            </div>
          </div>
        </div>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
